module.exports = __webpack_public_path__ + "static/img/class_18.d9364ba0.jpg";